// Activation status:
export const ACTIVATION_STATUS_INACTIVE = 0;
export const ACTIVATION_STATUS_OAUTH = 1;
export const ACTIVATION_STATUS_LOGIN = 1;
export const ACTIVATION_STATUS_TO_CHECK = 2;
export const ACTIVATION_STATUS_CHECKING = 3;
export const ACTIVATION_STATUS_INVALID = 4;
export const ACTIVATION_STATUS_ACTIVE = 5;
export const ACTIVATION_STATUS_ERROR = 6;
